import React from "react";

/**
 * ErrorBoundary global — capture toute erreur React non gérée et affiche un message
 * propre au lieu de la red box "Erreurs de runtime non capturées" du dev overlay CRA.
 * En production, l'overlay CRA est désactivé mais cette boundary reste protectrice.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info);
  }

  reset = () => {
    this.setState({ error: null });
    window.location.href = "/";
  };

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-app p-6">
          <div className="card max-w-md w-full text-center p-8" data-testid="error-boundary">
            <h2 className="font-display text-2xl mb-3" style={{ color: "var(--chalk)" }}>Oups, un imprévu</h2>
            <p className="text-sm text-[var(--ink-soft)] mb-5">
              Une erreur inattendue s'est produite. Cliquez ci-dessous pour relancer l'application.
            </p>
            <div className="text-[11px] font-mono text-[var(--grey)] mb-5 break-all rounded p-2 border border-[var(--border)] bg-[var(--carbon-3)]">
              {String(this.state.error?.message || this.state.error)}
            </div>
            <button onClick={this.reset} className="btn btn-primary w-full" data-testid="error-boundary-retry">
              Relancer l'application
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
